import { action, computed, observable } from 'mobx';
import { post } from '../../../services/request';
import Step1 from './Step1';
import Summary from './Summary';

export default class Store {
  steps = [
    { key: 'offers', title: 'Choose offers to reject', implementation: Step1 },
  ];

  @observable offers;

  @observable rejectedOffers = [];

  @observable message = '';

  summaryClass = Summary;

  @computed get eligibleOffersToReject() {
    if (!this.offers) return [];

    return this.offers
      .filter(
        (item) =>
          item.status === 'confirmed' ||
          item.status === 'accepted' ||
          item.status === 'awarded'
      )
      .sort((a, b) => b.submittedValue - a.submittedValue);
  }

  @computed get rejectedOfferDetails() {
    var lookup = this.offers.reduce((acc, i) => {
      acc[i.buyerId] = i;
      return acc;
    }, {});
    return this.rejectedOffers.map((o) => lookup[o]);
  }

  constructor(management) {
    this.offers = management.source.offers.viewModel.offers.map((item) => {
      return {
        item,
        buyerId: item.buyerId,
        name: `${item.buyer.buyer_lastName}, ${item.buyer.buyer_firstName}`,
        submittedValue: item.submittedValue,
        validity: item.data.offer_validity,
        status: item.status,
      };
    });
  }

  @action async submit(saleId, token) {
    await post(
      `/api/v1/wizard/${saleId}/reject`,
      {
        rejectOffers: this.rejectedOffers,
      },
      token
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/RejectSelected/index.js